/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventParameter
 */
export interface EventParameter {
    /**
     * 
     * @type {string}
     * @memberof EventParameter
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EventParameter
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof EventParameter
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof EventParameter
     */
    example?: string;
    /**
     * 
     * @type {string}
     * @memberof EventParameter
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof EventParameter
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EventParameter
     */
    optional?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventParameter
     */
    enum_values?: Array<string>;
    /**
     * Indicates if this parameter can be used as an email attachment (for PatientDocument IDs)
     * @type {boolean}
     * @memberof EventParameter
     */
    attachable?: boolean;
}

/**
 * Check if a given object implements the EventParameter interface.
 */
export function instanceOfEventParameter(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function EventParameterFromJSON(json: any): EventParameter {
    return EventParameterFromJSONTyped(json, false);
}

export function EventParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventParameter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'category': json['category'],
        'example': !exists(json, 'example') ? undefined : json['example'],
        'description': json['description'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'optional': !exists(json, 'optional') ? undefined : json['optional'],
        'enum_values': !exists(json, 'enum_values') ? undefined : json['enum_values'],
        'attachable': !exists(json, 'attachable') ? undefined : json['attachable'],
    };
}

export function EventParameterToJSON(value?: EventParameter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': value.type,
        'category': value.category,
        'example': value.example,
        'description': value.description,
        'value': value.value,
        'optional': value.optional,
        'enum_values': value.enum_values,
        'attachable': value.attachable,
    };
}

